import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0","key":"svg-0"}],["path",{"d":"M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0","key":"svg-1"}],["path",{"d":"M3 6l0 13","key":"svg-2"}],["path",{"d":"M12 6l0 13","key":"svg-3"}],["path",{"d":"M21 6l0 13","key":"svg-4"}]]

const IconBook = createReactComponent('outline', 'book', 'Book', __iconNode);

export default IconBook;